// @ts-nocheck
import * as Types from '../../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type ProjectScheduleTileQueryVariables = Types.Exact<{
  projectId: Types.Scalars['ID']['input'];
  stage: Types.Stage;
}>;


export type ProjectScheduleTileQuery = { __typename?: 'Query', schedules: Array<{ __typename?: 'Schedule', id: string, flagCount: number }>, scheduleTasks: Array<{ __typename?: 'ScheduleTask', id: string, name: string, statusDetail: { __typename?: 'TaskStatusDetail', code: Types.TaskStatus, name: string }, interval: { __typename?: 'CalendarInterval', startDate: Types.Scalars['Date']['input'], endDate: Types.Scalars['Date']['input'], durationInDays: number }, assignee?: { __typename?: 'InternalUser', id: string, avatar: string, name: string, user: { __typename?: 'User', id: string, avatar: string, name: string } } | null | undefined, globalPhase?: { __typename?: 'GlobalPhase', id: string } | null | undefined }> };

export type ScheduleTile_ScheduleFragment = { __typename?: 'Schedule', id: string, flagCount: number };

export type ScheduleTile_ScheduleTaskFragment = { __typename?: 'ScheduleTask', id: string, name: string, statusDetail: { __typename?: 'TaskStatusDetail', code: Types.TaskStatus, name: string }, interval: { __typename?: 'CalendarInterval', startDate: Types.Scalars['Date']['input'], endDate: Types.Scalars['Date']['input'], durationInDays: number }, assignee?: { __typename?: 'InternalUser', id: string, avatar: string, name: string, user: { __typename?: 'User', id: string, avatar: string, name: string } } | null | undefined, globalPhase?: { __typename?: 'GlobalPhase', id: string } | null | undefined };

export type ScheduleTile_CalendarIntervalFragment = { __typename?: 'CalendarInterval', startDate: Types.Scalars['Date']['input'], endDate: Types.Scalars['Date']['input'], durationInDays: number };

export type ScheduleTile_SchedulePhaseProgressFragment = { __typename?: 'SchedulePhaseProgress', scheduleSubPhaseProgress: { __typename?: 'ProgressSummary', status: Types.ProgressSummaryStatus, completed: number, total: number }, taskProgress: { __typename?: 'ProgressSummary', status: Types.ProgressSummaryStatus, total: number, completed: number } };

export const ScheduleTile_ScheduleFragmentDoc = gql`
    fragment ScheduleTile_Schedule on Schedule {
  id
  flagCount
}
    `;
export const ScheduleTile_CalendarIntervalFragmentDoc = gql`
    fragment ScheduleTile_CalendarInterval on CalendarInterval {
  startDate
  endDate
  durationInDays
}
    `;
export const ScheduleTile_ScheduleTaskFragmentDoc = gql`
    fragment ScheduleTile_ScheduleTask on ScheduleTask {
  id
  name
  statusDetail {
    code
    name
  }
  interval {
    ...ScheduleTile_CalendarInterval
  }
  assignee {
    id
    avatar
    name
    user {
      id
      avatar
      name
    }
  }
  globalPhase {
    id
  }
}
    ${ScheduleTile_CalendarIntervalFragmentDoc}`;
export const ScheduleTile_SchedulePhaseProgressFragmentDoc = gql`
    fragment ScheduleTile_SchedulePhaseProgress on SchedulePhaseProgress {
  scheduleSubPhaseProgress {
    status
    completed
    total
  }
  taskProgress {
    status
    total
    completed
  }
}
    `;
export const ProjectScheduleTileDocument = gql`
    query ProjectScheduleTile($projectId: ID!, $stage: Stage!) {
  schedules(filter: {parent: [$projectId], stage: [$stage]}) {
    ...ScheduleTile_Schedule
  }
  scheduleTasks(
    filter: {stage: [$stage], project: [$projectId], status: [IN_PROGRESS, NOT_STARTED, ON_HOLD, DELAYED]}
    first: 30
  ) {
    ...ScheduleTile_ScheduleTask
  }
}
    ${ScheduleTile_ScheduleFragmentDoc}
${ScheduleTile_ScheduleTaskFragmentDoc}`;

/**
 * __useProjectScheduleTileQuery__
 *
 * To run a query within a React component, call `useProjectScheduleTileQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectScheduleTileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectScheduleTileQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      stage: // value for 'stage'
 *   },
 * });
 */
export function useProjectScheduleTileQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProjectScheduleTileQuery, ProjectScheduleTileQueryVariables> & ({ variables: ProjectScheduleTileQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProjectScheduleTileQuery, ProjectScheduleTileQueryVariables>(ProjectScheduleTileDocument, options);
      }
export function useProjectScheduleTileLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProjectScheduleTileQuery, ProjectScheduleTileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProjectScheduleTileQuery, ProjectScheduleTileQueryVariables>(ProjectScheduleTileDocument, options);
        }
// @ts-ignore
export function useProjectScheduleTileSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ProjectScheduleTileQuery, ProjectScheduleTileQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProjectScheduleTileQuery, ProjectScheduleTileQueryVariables>;
export function useProjectScheduleTileSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectScheduleTileQuery, ProjectScheduleTileQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProjectScheduleTileQuery | undefined, ProjectScheduleTileQueryVariables>;
export function useProjectScheduleTileSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectScheduleTileQuery, ProjectScheduleTileQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProjectScheduleTileQuery, ProjectScheduleTileQueryVariables>(ProjectScheduleTileDocument, options);
        }
export type ProjectScheduleTileQueryHookResult = ReturnType<typeof useProjectScheduleTileQuery>;
export type ProjectScheduleTileLazyQueryHookResult = ReturnType<typeof useProjectScheduleTileLazyQuery>;
export type ProjectScheduleTileSuspenseQueryHookResult = ReturnType<typeof useProjectScheduleTileSuspenseQuery>;
export type ProjectScheduleTileQueryResult = Apollo.QueryResult<ProjectScheduleTileQuery, ProjectScheduleTileQueryVariables>;